/**
 * ###### 2018-09-02
 * @name axios 基于axios的Ajax异步请求方法的封装
 * @description 核心方法基于axios，配合Elememt-ui和后台的数据返回规则统一封装异步处理
 * @return 返回axios的实例，需要的时候直接引用
 *
 */
import Vue from 'vue';
import _axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import store from '../../store'
console.log(BUILD_ENV);
const hosts = require('../../../config/host.config');
const hostConfig = hosts[BUILD_ENV || 'local'];
window && (window.hostConfig = hostConfig);
_axios.interceptors.request.use(
  config => {
    config.headers = {
      'x-csrf-token': Vue.cookie.get('csrfToken')
    };
    let { userInfo } = store.state
    let data = config.data || {}
    // 避免emailAddress 被默认参数覆盖的问题
    // if (!data.emailAddress) {
      // data['emailAddress'] = userInfo.email
    // }
    data['token'] = Vue.cookie.get('token')
    if (config['dataType'] === 'JSON') {
      config.headers['oss-token'] = Vue.cookie.get('token');
      config.headers['Content-Type'] = 'application/json; charset=UTF-8';
      config['data'] = qs.parse(config.data);
    } else {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
      Object.assign(config, {
        withCredentials: false,
        transformRequest: params => qs.stringify(params),
        paramsSerializer: params => qs.stringify(params),
        data
      });
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
_axios.interceptors.response.use(
  res => {
    if (res.data && res.data instanceof Blob) {
      return res;
    }
    if (res.status == 200) {
      if (res.data.status) {
        if (res.data.status.code === '064300001') {
          Vue.cookie.delete('token');
          Message.error('未登录或登录已超时');
          let host = window.location.host + '/saasossplatform';
          let protocol = location.protocol
          window.location.href = `http://sso.huifenqi.com/sso/oauth/logout/?next=${protocol}//${host}/index/`;
          // next('/login');
          // Vue.$router.push('/login');
        } else if (res.data.status.code !== '0') {
          let {config} = res
          if(!config.noTips){
            Message.error(res.data.status.description);
          }
        }
        return res;
      } else {
        return res;
      }
    }
  },
  error => {
    let errorStr = String(error);
    if (/4[0-9]{1}/.test(errorStr)) {
      Message.error('接口不可用');
    }
    if (/5[0-9]{1}/.test(errorStr)) {
      Message.error('服务器忙，请稍后再试');
    }
    // 请求错误时做些事
    return Promise.reject(error);
  }
);

/**
 * 请求配置
 * @param  {Object} option [description]
 * @return {[type]}        [description]
 */
function getConfig(option = {}) {
  function getParams(args) {
    let params = args;

    delete params.data;
    delete params.host;
    delete params.method;

    return params;
  }

  return Object.assign(
    {
      method: option.method ? option.method.toUpperCase() : 'POST',
      // baseURL: BUILD_ENV ? hostConfig[option.host || 'oss'] : '',
      baseURL: hostConfig[option.host || 'oss'],
      data: option.data,
      processData: false,
      responseType: option.responseType || 'json'
    },
    getParams(option)
  );
}

function send(url, option) {
  let conf = getConfig(option);
  return _axios(url, conf);
}

function sendAll(options) {
  return _axios.all(
    options.map(item => {
      return axios(item.url, getConfig(item));
    })
  );
}

export default function request(url, option) {
  if (typeof url === 'string') {
    return send(url, option);
  } else if (url instanceof Array) {
    return sendAll(url);
  } else if (typeof url === 'object') {
    let params = url;
    return send(params.url, params);
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/axios.js